import "../coreNG";
import { animate } from "../coreNG";
import type { ICBLAnimationNG } from "./cbl-animationNG.interface";

export class CBLAnimationNG implements ICBLAnimationNG {
	private scrollableContainer_: HTMLElement | null;
	constructor() {
		this.scrollableContainer_ = null;
	}

	public animate = animate;

	public bindScrollableContainer(container: HTMLElement | null) {
		this.scrollableContainer_ = container;
	}

	public dispose() {
		this.scrollableContainer_ = null;
	}
}
